import { render, staticRenderFns } from "./k.vue?vue&type=template&id=aa297af2"
import script from "./k.vue?vue&type=script&lang=js"
export * from "./k.vue?vue&type=script&lang=js"
import style0 from "./k.vue?vue&type=style&index=0&id=aa297af2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports